import React, { useEffect, useState } from "react";
import { useNavigate,useLocation  } from "react-router-dom";
import { JWT_VAl } from "./Functions/jwt_validate";
import { Helmet } from "react-helmet";
import Header from "../Component/Header";
import Loader from "../Loader.gif";
import { createCookie, deleteCookie, getCookie } from "../CookieFunctions";
import { apihost, authhost,basehost } from "../ApiHost";


const IdeaValidator = () => {
  const location = useLocation(); // Get the location object
  const queryParams = new URLSearchParams(location.search)
  const navigate = useNavigate();
  const [problemSolutionPairs, setProblemSolutionPairs] = useState([
    { problem: "", solution: "" },
  ]);
  const [isLoading, setIsLoading] = useState(false);
  const [Errormsg, setError] = useState(null);
  const [features, setFeatures] = useState([""]);
  const [niches, setNiches] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [IsLoggedIn, setIsLoggedIn] = useState(false);
  const [credits, setCredits] = useState(0);
  const idea=JSON.parse(localStorage.getItem('idea'));

  const ValidationRequest=async(data)=>{
    setIsLoading(true);
    try {
      const response = await fetch(`${apihost}/validate`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getCookie("_JWT")}`,
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        const d = await response.json();
        localStorage.removeItem('idea');
        navigate(`/view/${d.Id}`);
        return 0;
      } else {
        setIsLoading(false);
        setError("Something went wrong, please try again.");
        return 1;
        // alert("Something went wrong, please try again.");
      }
    } catch (error) {
      setIsLoading(false);
      setError("Something went wrong, please try again.");
      alert("Error: " + error.message);
    }
  }
  const fetchCredits = async () => {
    try {
      const response = await fetch(`${apihost}/validate/credits`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${getCookie("_JWT")}`,
        },
      });
      if (!response.ok) {
        setCredits(0);
        console.error("Failed to fetch credits");
      }
      const data = await response.json();
      setCredits(data.credits || 0);
    } catch (error) {
      setCredits(0);
      console.error("Error fetching credits:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const JWT = await JWT_VAl();
      if (!JWT.success && !JWT.verified) {
        setIsLoggedIn(false);
      }
      else if (JWT.success && JWT.verified) {
        setIsLoggedIn(true);
      }
    };
    fetchData();
    fetchCredits();
    if(idea){
      ValidationRequest(idea);
    }
    if(queryParams.get('idea')){
      setDescription(queryParams.get('idea'));
    }
  }, [navigate,queryParams]);

  const maxInputs = 5;

  const addProblemSolution = () => {
    if (problemSolutionPairs.length < maxInputs) {
      setProblemSolutionPairs([
        ...problemSolutionPairs,
        { problem: "", solution: "" },
      ]);
    }
  };

  const removeProblemSolution = (index) => {
    const updatedPairs = problemSolutionPairs.filter((_, i) => i !== index);
    setProblemSolutionPairs(updatedPairs);
  };

  const handleInputChange = (index, field, value) => {
    const updatedPairs = [...problemSolutionPairs];
    updatedPairs[index][field] = value;
    setProblemSolutionPairs(updatedPairs);
  };

  const addFeature = () => {
    if (features.length < maxInputs) {
      setFeatures([...features, ""]);
    }
  };

  const removeFeature = (index) => {
    const updatedFeatures = features.filter((_, i) => i !== index);
    setFeatures(updatedFeatures);
  };

  const handleFeatureChange = (index, value) => {
    const updatedFeatures = [...features];
    updatedFeatures[index] = value;
    setFeatures(updatedFeatures);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      !title ||
      !niches ||
      !description ||
      problemSolutionPairs.some((pair) => !pair.problem || !pair.solution) ||
      features.some((feature) => !feature)
    ) {
      setError("Please fill all the details");
      return;
    }
    setIsLoading(true);
    const problemsAndSolutions = problemSolutionPairs.map((pair, index) => ({
      problemId: index + 1,
      problemStatement: pair.problem,
      solutionStatement: pair.solution,
    }));

    const data = {
      title: title,
      niches: niches,
      problemsAndSolutions: problemsAndSolutions,
      features: features,
      discription: description,
    };
    if (IsLoggedIn) {
    if (credits < 1) {
      setIsLoading(false);
      navigate("/plans");
      return;
    }
    await ValidationRequest(data);
  } else {
    localStorage.setItem('idea', JSON.stringify(data));
    createCookie("loginRedirect",basehost+'/home/validator' );
    window.location.href= authhost;
  }
  };

  return (
    <>
      <Header />
      {isLoading ?(
        <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-4 rounded-lg shadow-lg text-lg font-medium">
            <img src={Loader} alt="loading" className="w-20 h-20 mx-auto"/>
            Validating your idea...
            </div>
            </div>
          ): Errormsg ?(
            <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex items-center justify-center z-50">
              <div className="bg-white p-4 rounded-lg shadow-lg text-lg font-medium">
                <h2>{Errormsg}</h2>
                <p className="text-[red]">make sure to fills all details</p>
                <button onClick={() => setError(null)} className="block text-center w-full mt-4 bg-[rgb(100_65_233)] text-white py-2 rounded-md hover:bg-[rgb(85_50_210)] focus:outline-none">
                  Try Again 
                  </button>
              </div>
            </div>
          )
          :(
        <form onSubmit={handleSubmit} className="min-h-screen bg-[rgb(245_243_255)] flex items-center justify-center px-4">
        <div className="w-full max-w-4xl p-6 bg-white shadow-lg rounded-lg">
          <h1 className="text-3xl font-semibold text-[rgb(100_65_233)] mb-6 text-center">
            SAAS Idea Validator
          </h1>
          <div className="space-y-4">
            <div>
              <label className="block text-[rgb(100_65_233)] font-medium mb-2">
                Business Title
              </label>
              <input
                type="text"
                className="w-full border border-gray-300 rounded-md p-3 focus:outline-[rgb(100_65_233)] bg-gray-50"
                placeholder="Enter title"
                value={title}
                required={true}
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-[rgb(100_65_233)] font-medium mb-2">
                  Explain Idea
                </label>
                <textarea
                  className="w-full border border-gray-300 rounded-md p-3 focus:outline-[rgb(100_65_233)] bg-gray-50"
                  rows="6"
                  placeholder="Explain your idea..."
                  value={description}
                  required={true}
                  onChange={(e) => setDescription(e.target.value)}
                ></textarea>
              </div>
              <div className="space-y-4">
                <div>
                  <label className="block text-[rgb(100_65_233)] font-medium mb-2">
                    Business Type
                  </label>
                  <select required={true} className="w-full border border-gray-300 rounded-md p-3 focus:outline-[rgb(100_65_233)] bg-gray-50">
                    <option value="B2B">B2B</option>
                    <option value="B2C">B2C</option>
                    <option value="Both">Both</option>
                  </select>
                </div>
                <div>
                  <label className="block text-[rgb(100_65_233)] font-medium mb-2">
                    Business Niches
                  </label>
                  <input
                    type="text"
                    className="w-full border border-gray-300 rounded-md p-3 focus:outline-[rgb(100_65_233)] bg-gray-50"
                    placeholder="Enter Niches"
                    value={niches}
                    required={true}
                    onChange={(e) => setNiches(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="mt-8">
            <h2 className="text-lg font-medium text-[rgb(100_65_233)] mb-4">
              Problems Statement and Solution
            </h2>
            {problemSolutionPairs.map((pair, index) => (
              <div key={index} className="grid grid-cols-12 gap-4 mb-4">
                <input
                  type="text"
                  className="col-span-5 border border-gray-300 rounded-md p-3 focus:outline-[rgb(100_65_233)] bg-gray-50"
                  placeholder="Enter problem"
                  value={pair.problem}
                  required={true}
                  onChange={(e) =>
                    handleInputChange(index, "problem", e.target.value)
                  }
                />
                <input
                  type="text"
                  className="col-span-5 border border-gray-300 rounded-md p-3 focus:outline-[rgb(100_65_233)] bg-gray-50"
                  placeholder="Enter your solution"
                  value={pair.solution}
                  required={true}
                  onChange={(e) =>
                    handleInputChange(index, "solution", e.target.value)
                  }
                />
                {index === problemSolutionPairs.length - 1 &&
                  problemSolutionPairs.length < maxInputs && (
                    <button
                      onClick={addProblemSolution}
                      className="col-span-2 bg-[rgb(100_65_233)] text-white rounded-md flex items-center justify-center"
                    >
                      +
                    </button>
                  )}
                {index !== problemSolutionPairs.length - 1 && (
                  <button
                    onClick={() => removeProblemSolution(index)}
                    className="col-span-2 bg-red-500 text-white rounded-md flex items-center justify-center"
                  >
                    -
                  </button>
                )}
              </div>
            ))}
          </div>
          <div className="mt-6">
            <h2 className="text-lg font-medium text-[rgb(100_65_233)] mb-4">
              Features
            </h2>
            {features.map((feature, index) => (
              <div key={index} className="grid grid-cols-12 gap-4 mb-4">
                <input
                  type="text"
                  className="col-span-10 border border-gray-300 rounded-md p-3 focus:outline-[rgb(100_65_233)] bg-gray-50"
                  placeholder="Enter feature"
                  value={feature}
                  required={true}
                  onChange={(e) => handleFeatureChange(index, e.target.value)}
                />
                {index === features.length - 1 && features.length < maxInputs && (
                  <button
                    onClick={addFeature}
                    className="col-span-2 bg-[rgb(100_65_233)] text-white rounded-md flex items-center justify-center"
                  >
                    +
                  </button>
                )}
                {index !== features.length - 1 && (
                  <button
                    onClick={() => removeFeature(index)}
                    className="col-span-2 bg-red-500 text-white rounded-md flex items-center justify-center"
                  >
                    -
                  </button>
                )}
              </div>
            ))}
          </div>
          <div className="mt-6">
            <button
              type="submit"
              className="w-full bg-[rgb(100_65_233)] text-white py-3 rounded-md text-lg font-medium hover:bg-[rgb(85_50_210)] focus:outline-none"
            >
              Validate Idea
            </button>
          </div>
        </div>
        </form>
          )}
    </>
  );
};

export { IdeaValidator };
